import apiClient from './api_client_requests';

export default config => {
    return async payload => {
        let result = await apiClient(config).apiMethod({
            method: 'Winners',
            args: {
                game_id: config.promotion_id,
                draw_number:
                    typeof payload !== 'undefined' && payload.draw_number
                        ? payload.draw_number
                        : '',
            },
        });

        return {
            drawings: result.drawings,
        };
    };
};
